<template>
  <v-layout row justify-center>
    <CModal :show.sync="dialog" :title="dialogTitle" max-width="500px" scrollable>
        <v-progress-linear v-if="processing" :style="{ margin: 0 }" :indeterminate="true"></v-progress-linear>
        <v-container fill-height fluid :class="$style['card-container']">
          <v-layout nowrap>
            <v-flex>
              <v-card outlined :class="$style['card-content']">
                <v-card-text :class="$style['card-text']">
                  <form v-if="resourceName !== 'login'">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="{
                        required: 'required',
                        min: 6,
                      }"
                      name="パスワード"
                      vid="password"
                      ref="v-password"
                    >
                      <v-text-field
                        ref="password"
                        class="px-3"
                        v-model="password"
                        name="password"
                        type="password"
                        label="新パスワード"
                        clearable
                        prepend-icon="lock"
                        data-vv-as="新パスワード"
                        :error-messages="mergedErrorMessages(errors[0])"
                        :hide-details="true"
                      />
                      <ul :class="$style['error-messages']">
                        <li
                          v-for="(error,key) in mergedErrorMessages(errors[0])"
                          :key="key"
                        >{{error}}</li>
                      </ul>
                    </ValidationProvider>
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="{
                        required: 'required',
                        min: 6,
                        confirmed:'password'
                      }"
                      name="パスワード確認"
                      vid="passwordConfirm"
                      ref="v-password-confirm"
                    >
                      <v-text-field
                        class="px-3"
                        v-model="passwordConfirm"
                        name="passwordConfirm"
                        type="password"
                        label="新パスワード (確認用)"
                        clearable
                        prepend-icon="lock"
                        data-vv-as="新パスワード (確認用)"
                        :error-messages="mergedConfirmErrorMessages(errors[0])"
                        :hide-details="true"
                      />
                      <ul :class="$style['error-messages']">
                        <li
                          v-for="(error,key) in mergedConfirmErrorMessages(errors[0])"
                          :key="key"
                        >{{error}}</li>
                      </ul>
                    </ValidationProvider>
                  </form>
                  <form v-else>
                    <v-card elevation="0" class="pa-3"
                      >※ご登録済みのメールアドレスをご入力ください。</v-card
                    >
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="{
                        required: 'required',
                      }"
                      name="メールアドレス"
                      vid="email"
                      ref="v-email"
                    >
                      <v-text-field
                        class="mt-4"
                        v-model="email"
                        label="メールアドレス"
                        outlined
                        clearable
                        background-color="#fff"
                        :error-messages="mergedEmailErrorMessages(errors[0])"
                      ></v-text-field>
                    </ValidationProvider>
                  </form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
          <template #footer>
            <CButton
                    v-if="resourceName !== 'login'"
                    :class="$style['reset-dialog-btn']"
                    color="primary"
                    @click="submit"
            >更新</CButton>
            <CButton
                    v-else
                    :class="$style['reset-dialog-btn']"
                    color="primary"
                    @click="submit"
            >送信</CButton>
          </template>
    </CModal>
  </v-layout>
</template>

<script>
export default {
  props: {
    resourceName: {
      type: String
    }
  },
  data() {
    return {
      email: ""
    };
  },
  watch: {
    dialog(show) {
      const vm = this;
      if (!show) {
        if (this.resourceName !== 'login') {
          const passwordProvidor = vm.$refs["v-password"];
          const passwordConfirmProvidor = vm.$refs["v-password-confirm"];
          passwordProvidor.reset();
          passwordConfirmProvidor.reset();
        } else {
          const emailProvidor = vm.$refs["v-email"];
          emailProvidor.reset();
        }
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.$store.getters["passwordReissue/open"];
      },
      set(value) {
        this.$store.commit("passwordReissue/close");
      }
    },
    password: {
      get() {
        return this.$store.getters["passwordReissue/password"];
      },
      set(value) {
        this.$store.commit("passwordReissue/updatePassword", {
          password: value
        });
      }
    },
    passwordConfirm: {
      get() {
        return this.$store.getters["passwordReissue/passwordConfirm"];
      },
      set(value) {
        this.$store.commit("passwordReissue/updatePasswordConfirm", {
          passwordConfirm: value
        });
      }
    },
    processing() {
      return this.$store.getters["passwordReissue/processing"];
    },
    dialogTitle() {
      if (this.resourceName === 'login') {
        return "パスワード再発行";
      }
      return "パスワード変更";
    },
    errorMessages() {
      return this.$store.getters[`passwordReissue/errorMessages`] || {};
    },
    mergedErrorMessages() {
      return vvErr => {
        const messages = [];
        const errorMessages = (this.errorMessages || {}).password || [];
        if (vvErr) {
          messages.push(vvErr);
        }
        if (errorMessages.length) {
          errorMessages.forEach(v => messages.push(v));
        }
        return messages;
      };
    },
    mergedConfirmErrorMessages() {
      return vvErr => {
        const messages = [];
        if (vvErr) {
          messages.push(vvErr);
        }
        return messages;
      };
    },
    mergedEmailErrorMessages() {
      return vvErr => {
        const messages = [];
        const errorMessages = (this.errorMessages || {}).email || [];
        if (vvErr) {
          messages.push(vvErr);
        }
        if (errorMessages.length) {
          errorMessages.forEach(v => messages.push(v));
        }
        return messages;
      };
    },
    pk() {
      return this.$store.getters["passwordReissue/pk"];
    }
  },
  methods: {
    async submit() {
      if (this.resourceName !== 'login') {
        const passwordProvidor = this.$refs["v-password"];
        const passwordConfirmProvidor = this.$refs["v-password-confirm"];
        const passwordResult = await passwordProvidor.validate();
        const confirmResult = await passwordConfirmProvidor.validate();
        if (passwordResult.valid && confirmResult.valid) {
          this.$store
            .dispatch("passwordReissue/reissue", {
              resourceName: this.resourceName
            })
            .then(() => {
              this.$message({
                message: "パスワードを変更しました。",
                type: "success"
              });
            });
        }
      } else {
        const emailProvidor = this.$refs["v-email"];
        const emailResult = await emailProvidor.validate();
        if (emailResult.valid) {
          this.$store
            .dispatch("passwordReissue/reissueByEmail", {
              email: this.email
            })
            .then(() => {
              this.$message({
                message: "ご登録のパスワード宛にパスワードをお送りいたしました。メールをご確認ください。",
                type: "success"
              });
            });
        }
      }
    }
  }
};
</script>

<style module lang="scss">
.card-container {
  padding: 0px !important;
  border-bottom: 1px solid #eee;
}
.card-text {
  padding: 0px !important;
}
.card-content {
  overflow-y: auto;
  padding: 8px 0 !important;
  border: none !important;
}
.error-messages {
  margin: 0;
  margin-top: 8px !important;
  padding-left: 46px !important;
  & > li {
    list-style-type: none;
    min-height: 23px;
    line-height: 12px;
    font-size: 12px;
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
  }
}
.reset-dialog-btn {
  & > span {
    font-size: 14px !important;
  }
}
</style>
<style lang="scss">
.v-card__title {
  font-size: 14px !important;
}
</style>
